import { carouselItems } from '@/mocks/movies';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            本周焦点
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精选专题策划，带你发现被窝影院电影大全免费看的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 relative aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}